import GlobalLoader from "@/components/Loading/GlobalLoader"
import styles from "./tournament-browser.module.css"
import TournamentCard from "./TournamentCard"

export default function TournamentBrowser({ tournaments, isLoading }) {
  return (
    <section className={styles.browserSection}>
      <div className={styles.resultsHeader}>
        <h2 className={styles.resultsTitle}>
          Tournaments
        </h2>
      </div>
      
      {tournaments.length > 0 ? (
        <div className={styles.tournamentsGrid}>
          {tournaments.map((tournament) => (
            <TournamentCard key={tournament._id} tournament={tournament} />
          ))}
        </div>
      ) : isLoading ? (
        <div className={styles.noResults}>
          <GlobalLoader isLoading={isLoading} variant="spinner" message="Loading tournaments" />
        </div>
      ) : (
        <div className={styles.noResults}>
          <div className={styles.noResultsIcon}>🎮</div>
          <h3 className={styles.noResultsTitle}>No Tournaments Found</h3>
          <p className={styles.noResultsText}>Try adjusting your filters or search query</p>
        </div>
      )}
    </section>
  )
}
